/**
 * Application context service locator.
 *
 * Holds references to the Vuex store and Vue Router set during app init (main.js).
 * Exported as Proxy objects
 * So callers such as non-Vue files like utilities and API Clients
 * can import { store, router } from here
 * and call functions naturally while avoiding circular import dependencies
 */

let storeInstance = null;
let routerInstance = null;

export function setStore(instance) {
  storeInstance = instance;
}

export function setRouter(instance) {
  routerInstance = instance;
}

// Proxy -> get for properties return the real value from the instance
// If the usage is `this` through a fucntion for the store or router,
// the methods fail, so we need to bind the real instance to the usage also
export const store = new Proxy(
  {},
  {
    get(_, prop) {
      const val = storeInstance?.[prop];
      return typeof val === 'function' ? val.bind(storeInstance) : val;
    },
  },
);

export const router = new Proxy(
  {},
  {
    get(_, prop) {
      const val = routerInstance?.[prop];
      return typeof val === 'function' ? val.bind(routerInstance) : val;
    },
  },
);
